module.exports = __webpack_public_path__ + "static/media/blanket-state-2.3bdd7947.wav";